import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import uniq from 'lodash-es/uniq';
import compact from 'lodash-es/compact';
import { DATA } from '@/plugins/vuex-async-pagginate';

class CountryServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params) {
    return this.http.get('country', { params: params });
  }

  getTypesByCountry(country_iso) {
    return this.http.get('types', { params: { country_iso: [country_iso] } }).then((res) => res[DATA]);
  }

  getRegions(country_iso_code, type) {
    return this.http.post('data', { countryIsoCode: [country_iso_code], type: type }).then((res) => {
      const regions = res[DATA].map((i) => i.region);
      return uniq(compact(regions));
    });
  }

  getSelect(params) {
    return this.getList(params).then((res) => res[DATA]);
  }
}

export const CountryService = new CountryServiceClass({
  api_version: 2,
  resource: 'phones/integration'
});
